export const downloadFile = (res) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    const fileName = { ...res.headers }['content-disposition'];

    if(fileName){
        let name = fileName.split(' ')[1].slice(9).slice(1, -1);
        link.href = url;
        link.setAttribute('download', `${name}`);
        link.click();
    }
}